"use client"
import React, { useEffect, useMemo, useState } from 'react';
import './style.css';
import Helper from '../../util/helper';
import formatMsg from '../../util/formatMsg';
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Download from "yet-another-react-lightbox/plugins/download";
import Counter from "yet-another-react-lightbox/plugins/counter";
import "yet-another-react-lightbox/plugins/counter.css";
import Fullscreen from "yet-another-react-lightbox/plugins/fullscreen";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Video from "yet-another-react-lightbox/plugins/video";
import Inline from "yet-another-react-lightbox/plugins/inline";
import { ActivityLikeCommentsModal, NewPopoverOptions, permissions, useIsMobile } from '../..';
import { Avatar, Input, List, Modal, Progress, Skeleton, Switch, Tooltip } from 'antd';
import { useDispatch } from 'react-redux';
import { deleteActivityPost, likeActivity, activeInactiveActivity } from '../../redux/activity/reducer';
import { WarningOutlined } from "@ant-design/icons"

const page = (props) => {
    const { activityObj, peopleIdToObjMap, disabled } = props;
    const isMobile = useIsMobile();
    const dispatch = useDispatch();
    const { firebase, activityReducer } = Helper.getSelectorState(["login", "activityReducer"]);

    const [isPreviewOpen, setIsPreviewOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showActivityLikeCommentsModal, setShowActivityLikeCommentsModal]: any = useState(false);
    const [view, setView] = useState(undefined);
    const [liked, setLiked] = useState(false);
    const [likesCount, setLikesCount] = useState(activityObj.likes?.length ?? 0);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const toggleOpen = (state: boolean) => () => setIsPreviewOpen(state);
    const updateIndex = ({ index: current }: { index: number }) =>
        setCurrentIndex(current);

    useEffect(() => {
        const id = Helper.getUrlParam("id") || Helper.getUrlParam("nodeId");
        const type = Helper.getUrlParam("type") || Helper.getUrlParam("subType");
        if (id === activityObj.id && type) {
            // setIsPreviewOpen(true);
            if (type === "like") {
                setView("LIKES");
                setShowActivityLikeCommentsModal(true);
            } else if (type === "comment") {
                setView("COMMENTS");
                setShowActivityLikeCommentsModal(true);
            }
            Helper.setUrlParam("id", "");
            Helper.setUrlParam("type", "");
            // Helper.setUrlParam("nodeId", "");
            // Helper.setUrlParam("subType", "");
        }
    }, [])

    useEffect(() => {
        if (showActivityLikeCommentsModal) showOverlay();
        else hideOverlay();
    }, [showActivityLikeCommentsModal]);

    function showOverlay() {
        document.documentElement.style.overflow = 'hidden';
    }

    function hideOverlay() {
        document.documentElement.style.overflow = ''
    }


    const handleStatusChange = (value: string) => {
        if (value === "INACTIVE") {
            Modal.confirm({
                title: "Deactivate Post?",
                content: (
                    <p style={{ whiteSpace: "wrap" }}>
                        {formatMsg("confirm.inactivePost")}
                    </p>
                ),
                okText: "Yes",
                cancelText: "Cancel",
                onOk: () => {
                    dispatch(activeInactiveActivity({ firebase, activityId: activityObj.id, status: "INACTIVE" }));
                    Modal.destroyAll();
                },
                onCancel: () => Modal.destroyAll(),
                okButtonProps: {
                    style: { background: "var(--primary-color)" }
                }
            });
        }
    };


    const getOptions = () => {
        let options: any = [];
        if (activityObj.authorId === firebase.user.id) {
            if (activityObj.status === "SUCCESS" && permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.FEED_EDIT_POST, activityObj.centerIds)) options.push({
                image: "/images/editV2Icon.png",
                title: formatMsg("edit"),
                redirect: true,
                path: "/dashboard/timeline/createActivity?id=" + activityObj.id,
            })
            if (permissions.hasPermissionForEntity(firebase, activityObj.inactive ? permissions.PERMISSIONS.FEED_ACTIVE : permissions.PERMISSIONS.FEED_INACTIVE, activityObj.centerIds)) options.push({
                title: <div className="switch-option">
                    <Switch
                        checked={!activityObj.inactive}
                        onChange={() => {
                            setIsPopupOpen(false)
                            !activityObj.inactive ?
                                handleStatusChange("INACTIVE") :
                                dispatch(activeInactiveActivity({ firebase, activityId: activityObj.id, status: "ACTIVE" }));
                        }}
                        size="small"
                        style={{ marginRight: "8px" }}
                    />
                    <span style={{ color: activityObj.inactive ? "#8D8D8D" : "#333", fontWeight: 400 }}>
                        {formatMsg("active") + "/"}
                    </span>
                    <span style={{ color: activityObj.inactive ? "#333" : "#8D8D8D", fontWeight: 400 }}>
                        {formatMsg("inactive")}
                    </span>
                </div>
            })
            if (permissions.hasPermissionForEntity(firebase, permissions.PERMISSIONS.FEED_DELETE, activityObj.centerIds)) options.push({
                image: "/images/delete.png",
                title: formatMsg("delete"),
                action: () => {
                    setIsPopupOpen(false)
                    Modal.confirm({
                        title: formatMsg('deleteActivity'),
                        content: (
                            <p style={{ whiteSpace: "wrap" }}>
                                {formatMsg("deleteActivityConfirm") + " " + "?"}
                            </p>
                        ),
                        okText: "Delete",
                        cancelText: "Cancel",
                        onOk: () => {
                            dispatch(deleteActivityPost({ firebase: firebase, id: activityObj.id }))
                            Modal.destroyAll();
                        },
                        onCancel: () => Modal.destroyAll(),
                        okButtonProps: {
                            style: { background: "var(--primary-color)" }
                        }
                    });
                }
            })
        }
        return options
    }

    useEffect(() => {
        const userId = firebase?.user?.id;
        const likes = activityObj?.likes || [];

        if (!likes.length) {
            setLiked(false);
            setLikesCount(0)
            return;
        }

        const hasLiked = likes.some(like => like.userId === userId);
        setLiked(hasLiked);
        setLikesCount(likes.length);
    }, [activityObj, firebase, peopleIdToObjMap]);

    const handleLike = async () => {
        if (disabled) return;

        const optimisticLiked = !liked;
        const delta = optimisticLiked ? +1 : -1;

        setLiked(optimisticLiked);
        setLikesCount(c => c + delta);
        dispatch(likeActivity(
            {
                firebase,
                reqObj: {
                    userId: firebase?.user?.id,
                    userType: firebase?.user?.userType,
                    activityPostId: activityObj.id,
                    userName: firebase.user.name,
                    userProfilePicture: firebase.user.profilePhoto || firebase.user.profileImageUrl || firebase.user.authorProfileUrl || null,
                    liked: optimisticLiked
                }
            }
        ))
    };

    const renderTagContent = () => (
        <List
            size="small"
            dataSource={activityObj.taggedUsers}
            style={{ maxHeight: "200px", overflowY: "auto" }}
            renderItem={(u: any) => {
                return (
                    <List.Item key={u.userId} style={{ width: "220px", padding: "2px 8px" }}>
                        <List.Item.Meta
                            avatar={
                                u.userProfilePicture ?
                                    <Avatar src={u.userProfilePicture} size={24} style={{ border: "1px solid white", borderRadius: "50%" }} /> :
                                    <Avatar size={24} style={{ border: "1px solid white", borderRadius: "50%" }}>{u?.userName?.slice(0, 1)}</Avatar>
                            }
                            title={
                                <div>
                                    <div style={{ color: "white", fontSize: "var(--font-size-12)", fontWeight: 500 }}>{u.userName}</div>
                                    <div style={{ color: "white", fontSize: "var(--font-size-11)", fontWeight: 400 }}>{formatMsg(u.userType, undefined, firebase)}</div>
                                </div>
                            }
                        />
                    </List.Item>
                )
            }}
        />
    );

    const makeSlides = (mediaProfiles) => {
        return mediaProfiles ? mediaProfiles.map((item) =>
            item.type.includes("video")
                ? ({
                    type: "video",
                    sources: [
                        {
                            src: item.path || item.url || item.preview,
                            type: "video/mp4",
                        },
                    ],
                } as const)
                : ({
                    src: item.path || item.url || item.preview,
                    type: "image",
                } as const)
        ) : []
    }

    const slides = useMemo(() => makeSlides(activityObj.mediaProfiles), [
        activityObj.mediaProfiles,
    ]);

    return (
        <>
            <div
                className="activityPreview-container"
                style={{ opacity: activityObj.inactive ? 0.6 : undefined, backgroundColor: activityObj.inactive ? "#f2f2f2" : undefined }}
                onClick={() => console.log(activityObj.id)}
            >
                <div className="activityPreview-header">
                    <div className="activityPreview-userInfo">
                        <img
                            className='activityPreview-profileIconStyle'
                            src={Helper.getProfileImageUrl(peopleIdToObjMap?.get(activityObj.authorId) || activityObj)}
                        />
                        <div className="activityPreview-userDetails">
                            <div className="activityPreview-username">{activityObj?.authorName || formatMsg("alexander")}</div>
                            <div className="activityPreview-timestamp-container">
                                <div className="activityPreview-timestamp">{Helper.timeAgo(activityObj.createdOn)}</div>
                                <div className='activityPreview-timestamp' style={{ marginLeft: 2, marginRight: 2 }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="2" height="3" viewBox="0 0 2 3" fill="none">
                                        <circle cx="1" cy="1.5" r="1" fill="#5B5B5B" />
                                    </svg>
                                </div>
                                <Tooltip title={formatMsg(Helper.getVisibilityIcon(activityObj.visibility).key)}>
                                    <img
                                        src={`/images/${Helper.getVisibilityIcon(activityObj.visibility).icon}`}
                                        alt="globe"
                                        className="activityPreview-globe-icon"
                                    />
                                </Tooltip>
                                {activityObj.inactive &&
                                    <>
                                        <div className='activityPreview-timestamp' style={{ marginLeft: 2, marginRight: 2 }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="2" height="3" viewBox="0 0 2 3" fill="none">
                                                <circle cx="1" cy="1.5" r="1" fill="#5B5B5B" />
                                            </svg>
                                        </div>
                                        <div className="activityPreview-timestamp" style={{ color: "red" }}>{formatMsg("inactive")}</div>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                    <div className='activityPreview-header-right'>
                        {Helper.renderActivityType(activityObj.activityType, activityReducer.activityType, isMobile, null, activityObj.customActivityObject)}
                        {
                            activityObj.status !== "INPROGRESS" && !Helper.isAccount(firebase) && Helper.isUserLoggedIn(firebase) && !disabled && getOptions().length > 0 &&
                            <NewPopoverOptions
                                open={isPopupOpen}
                                setOpen={setIsPopupOpen}
                                options={getOptions()}
                            />
                        }
                    </div>
                </div>
                {activityObj.status === "INPROGRESS" ?
                    <>
                        <Progress percent={Math.floor(((activityObj.mediaProfiles?.length || 0) / (activityObj.mediaCount || 1)) * 100)} />
                        <Skeleton active title={false} />
                    </> :
                    activityObj.status === "SUCCESS" ?
                        <>
                            {activityObj.mediaProfiles && (
                                <div style={{ position: "relative" }}>
                                    <Lightbox
                                        index={currentIndex}
                                        slides={slides}
                                        video={{ autoPlay: true, playsInline: true, preload: "auto", muted: true }}
                                        plugins={[Inline, Video]}
                                        on={{
                                            view:
                                                activityObj.mediaProfiles.length > 1 ? updateIndex : undefined,
                                            click: toggleOpen(true),
                                        }}
                                        carousel={{ padding: 0, spacing: 0, imageFit: "cover" }}
                                        render={{
                                            buttonPrev:
                                                activityObj.mediaProfiles.length === 1 ? () => null : undefined,
                                            buttonNext:
                                                activityObj.mediaProfiles.length === 1 ? () => null : undefined,
                                        }}
                                        inline={{
                                            style: {
                                                width: "100%",
                                                maxWidth: "900px",
                                                aspectRatio: "3 / 2",
                                                margin: "0 auto",
                                                height: "480px",
                                            },
                                        }}
                                        className="activity-yarl"
                                    />

                                    {activityObj.taggedUsers?.length > 0 && (
                                        <Tooltip
                                            title={
                                                <>
                                                    <h4 style={{ marginBottom: 5 }}>{formatMsg("tagged")}</h4>
                                                    {renderTagContent()}
                                                </>
                                            }
                                            placement="topLeft"
                                        >
                                            <img
                                                src="/images/tagPeople.png"
                                                alt="tagged users"
                                                className="activityPreview-footer-icon"
                                                style={{ position: "absolute", bottom: 8, left: 8, filter: "drop-shadow(0 0 4px rgba(0, 0, 0, 0.35))" }}
                                            />
                                        </Tooltip>
                                    )}
                                </div>
                            )}

                            {
                                isPreviewOpen && activityObj.mediaProfiles &&
                                <Lightbox
                                    open={isPreviewOpen}
                                    index={currentIndex}
                                    close={() => setIsPreviewOpen(false)}
                                    slides={slides}
                                    plugins={[Download, Counter, Fullscreen, Thumbnails, Zoom, Video]}
                                    video={{ autoPlay: true, playsInline: true, preload: "auto", muted: true }}
                                    counter={{
                                        container: {
                                            style: { top: "unset", bottom: 0, left: "50%", transform: "translateX(-50%)" },
                                        },
                                    }}
                                    controller={{ closeOnBackdropClick: true, closeOnPullUp: true }}
                                    render={{
                                        buttonPrev: activityObj.mediaProfiles.length === 1 ? () => null : undefined,
                                        buttonNext: activityObj.mediaProfiles.length === 1 ? () => null : undefined,
                                    }}
                                />
                            }

                            {
                                activityObj.mediaProfiles && activityObj.mediaProfiles.length > 1 &&
                                <div className="activityPreview-dotContainer">
                                    {activityObj.mediaProfiles.map((_, index) => {
                                        return (
                                            <div
                                                className={`dot ${index === currentIndex ? "active" : ""}`}>
                                            </div>
                                        )
                                    })}
                                </div>
                            }

                            {
                                !activityObj.mediaProfiles &&
                                <>
                                    <div className="activityPreview-caption" dangerouslySetInnerHTML={{ __html: activityObj.description }} />
                                    {activityObj.taggedUsers?.length > 0 && (
                                        <Tooltip
                                            title={Helper.isUserLoggedIn(firebase) ?
                                                <>
                                                    <h4 style={{ marginBottom: 5 }}>{formatMsg("tagged")}</h4>
                                                    {renderTagContent()}
                                                </> : undefined
                                            }
                                            placement="topLeft"
                                        >
                                            <img
                                                src="/images/tagPeople.png"
                                                alt="tagged users"
                                                className="activityPreview-footer-icon"
                                            />
                                        </Tooltip>
                                    )}
                                </>
                            }

                            <div className="activityPreview-interactions">
                                <div className="activityPreview-stats">

                                    <div className="activity-statItem">
                                        {
                                            liked ? (<img
                                                src="/images/heart.png"
                                                onClick={!disabled ? handleLike : undefined}
                                                className="activityPreview-statItem-like-icon"
                                                alt="heart"
                                                style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
                                            />) : (
                                                <img
                                                    src="/images/blank_heart.png"
                                                    onClick={!disabled ? handleLike : undefined}
                                                    className="activityPreview-statItem-blank-heart-icon"
                                                    alt="heart"
                                                    style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
                                                />
                                            )
                                        }
                                        <div
                                            style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
                                            className="activity-like-comment-count"
                                            onClick={() => {
                                                if (!disabled && likesCount) {
                                                    setView("LIKES");
                                                    setShowActivityLikeCommentsModal(true);
                                                }
                                            }}
                                        >
                                            {likesCount || 0}
                                        </div>
                                    </div>
                                    {!activityObj.commentsOff && <div
                                        className="activityPreview-statItem"
                                        style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer" }}
                                        onClick={() => {
                                            if (!disabled) {
                                                setView("COMMENTS");
                                                setShowActivityLikeCommentsModal(true);
                                            }
                                        }}
                                    >
                                        <img
                                            src="/images/chat.png"
                                            className="activityPreview-statItem-icon"
                                            alt="chat"
                                        />
                                        <div className="activity-like-comment-count">{activityObj.commentCount || 0}</div>
                                    </div>
                                    }
                                </div>
                            </div>


                            {
                                activityObj.mediaProfiles &&
                                <div className="activityPreview-caption" dangerouslySetInnerHTML={{ __html: activityObj.description }}>
                                </div>
                            }

                            {!activityObj.commentsOff && <Input
                                placeholder={formatMsg("addComments")}
                                prefix={<img src="/images/smileEmoji.png" className="activity-comments-icon" alt="smile-icon" style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer", background: 'transparent', border: 'none', marginRight: 5 }} />}
                                suffix={<img src="/images/commentsArrow.png" className="activity-comments-icon" alt="comments-arrow" style={{ opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer", background: 'transparent', border: 'none', marginLeft: 5 }} />}
                                style={{ padding: isMobile ? "8px 12px" : "12px 16px", border: "1px solid #8D8D8D", backgroundColor: "#F8F8F8", borderRadius: "32px", opacity: disabled ? 0.5 : 1 }}
                                className='activity-addComments'
                                onFocus={() => {
                                    setView("COMMENTS");
                                    setShowActivityLikeCommentsModal("comment")
                                }}
                                disabled={disabled}
                            />
                            }
                        </> : <div style={{ color: "red" }}><WarningOutlined />&nbsp;&nbsp;{formatMsg("failedActivity")}</div>
                }
            </div>
            {
                showActivityLikeCommentsModal &&
                <ActivityLikeCommentsModal
                    view={view}
                    showActivityLikeCommentsModal={showActivityLikeCommentsModal}
                    setShowActivityLikeCommentsModal={setShowActivityLikeCommentsModal}
                    activityObj={activityObj}
                    liked={liked}
                    likeList={activityObj.likes || []}
                    likesCount={likesCount}
                    handleLike={handleLike}
                />
            }
        </>
    );
};

export default page;